// ActionButtons.js
import { Button, Group } from "@mantine/core";
import React from "react";

const ActionButtons = ({ onCancel, type, activeTab, onSave, loading }) => {
  return (
    <Group grow>
      <Button
        fullWidth
        color="gray"
        variant="light"
        c={"var(--app-text)"}
        onClick={onCancel}
        style={{ width: "50%" }}
      >
        Cancel
      </Button>
      <Button
        fullWidth
        c={"var(--app-on-primary)"}
        color="yellow"
        onClick={onSave}
        loading={loading}
        type={type}
        style={{ width: "50%" }}
      >
        {activeTab === "settings" ? "Save" : "Next"}
      </Button>
    </Group>
  );
};

export default ActionButtons;
